import { createFileRoute } from '@tanstack/react-router'
import { guardAuthenticated } from '@/lib/auth/routeGuards'
import CardView from '@/components/shared/CardView'
export const Route = createFileRoute('/card')({
  component: RouteComponent,
  beforeLoad: guardAuthenticated,
})

function RouteComponent() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-2xl mx-auto">
        <CardView />
      </div>
    </div>
  )
}
